<template>
	<div>
		<div :id="status.status + '_folded'" class="w3-center" style="display: none;">
			<h1>
				<i class="fa fa-chevron-circle-up w3-text-deep-orange cursor-pointer flow-no-padding-top"
					 @click="unfold(status.status)"></i></h1>
			<h1><b>{{ $t(status.status) }}</b></h1>
		</div>
		<div :id="status.status+'_open'">
			<h1 class="flow-content-header"><b>{{ $t(status.status) }}</b>
				<i class="fa fa-chevron-circle-left w3-text-deep-orange w3-right cursor-pointer"
					 @click="fold(status.status)"></i>
			</h1>

			<div v-if="appointments && appointments.length === 0">
				<div class="w3-center flow-blue-color flow-padding-top">
					<b class="w3-panel">{{ $t("noPatients") }}</b>
				</div>
			</div>

			<div v-else :id="status.status+'_cards'" class="flow-padding-top">
				<div v-for="appointment in sortedPatients" @click="removeNotify(appointment, status.status)">

					<!--Get patient card-->
					<patientCard :appointment="appointment"
											 :appointmentStatus="status"
											 :plugin="plugin"
											 :statuses="statuses"
											 :notify="isNotify(appointment)">
					</patientCard>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import patientCard from "./dhPatientCard";
import Vue from 'vue';
import {EventBus} from "@/main";

export default {
	name: "statusColumn",
	components: {patientCard},
	props: ['status', 'appointments', 'statuses', 'checkNotifications', 'plugin'],
	data: function () {
		return {
			oldAppointments: this.appointments,
			lsMap: {},
			showNotify: []
		}
	},
	watch: {
		appointments(newList) {
			this.compare(newList, this.oldAppointments);
			this.oldAppointments = this.appointments;
		},
		showNotify(newList) {
			this.lsMap[this.status.status] = newList;
			localStorage.setItem("notifyAppointments" + this.plugin, JSON.stringify(this.lsMap));
			this.checkNotifications();
		}
	},
	computed: {
		sortedPatients() {
			return this.sortPatients(this.appointments);
		}
	},
	beforeDestroy() {
		EventBus.$off("removeAllNotifications", this.removeAllNotify);
	},
	mounted() {
		if (this.appointments) this.oldAppointments = this.appointments;
		this.getLSitems();
		EventBus.$on("removeAllNotifications", this.removeAllNotify);
	},
	methods: {
		getLSitems() {
			let app = this;
			let items = localStorage.getItem("notifyAppointments" + app.plugin);
			let lsitems = {};
			if (items) {
				lsitems = JSON.parse(items);
				app.showNotify = lsitems[app.status.status];
			} else {
				app.showNotify = [];
				app.statuses.forEach(function (s) {
					lsitems[s.status] = [];
				})
			}
			this.lsMap = lsitems;
		},
		compare(newList, oldList) {
			let app = this;
			let lastMoved = Vue.prototype.$forwardedAppointmentDH;
			let lastMovedID = lastMoved !== undefined ? lastMoved.patient.appointmentId : null;
			let lastMovedStatus = lastMoved !== undefined ? lastMoved.toStatus : null;
			newList.forEach(function (newApp) {
				if (!app.checkInArray(newApp.appointmentId, oldList)) {
					if (lastMovedID === newApp.appointmentId) {
						if (lastMovedStatus !== newApp.currentStatus) {
							app.pushInNotify(newApp);
						}
					} else {
						app.pushInNotify(newApp);
					}
				}
			});
		},
		pushInNotify(appointment) {
			let app = this;
			let items = localStorage.getItem("notifyAppointments" + this.plugin);
			let lsitems = {};
			if (items) {
				lsitems = JSON.parse(items);
			} else {
				app.statuses.forEach(function (s) {
					lsitems[s.status] = [];
				})
			}
			app.statuses.forEach(function (s) {
				let appointments = lsitems[s.status];
				for (let i = 0; i < appointments.length; i++) {
					if (appointment.appointmentId === appointments[i]) {
						appointments.splice(i, 1);
					}
				}
				lsitems[s.status] = appointments;
			});
			app.lsMap = lsitems;
			app.showNotify.push(appointment.appointmentId);
		},
		sortPatients(patients) {
			if (patients) patients.sort(this.comparator);
			return patients;
		},
		comparator(a, b) {
			let status = this.status.status;
			let aTime, bTime;

			if (status === 'RECOVERY') {
				aTime = a.appointmentTypeStatusChangedAt;
				bTime = b.appointmentTypeStatusChangedAt;
			} else if (status === 'CDC') {
				aTime = b.appointmentTypeStatusChangedAt;
				bTime = a.appointmentTypeStatusChangedAt;
			} else {
				return a.appointmentTime.localeCompare(b.appointmentTime);
			}

			if (!aTime) return 1;
			if (!bTime) return -1;

			return aTime - bTime;
		},
		fold: function (id) {
			let foldedId = id + "_folded";
			let openId = id + "_open";
			document.getElementById(id).classList.add('folded');
			document.getElementById(foldedId).style.display = 'block';
			document.getElementById(openId).style.display = 'none';
		},
		unfold: function (id) {
			let foldedId = id + "_folded";
			let openId = id + "_open";
			document.getElementById(id).classList.remove('folded');
			document.getElementById(foldedId).style.display = 'none';
			document.getElementById(openId).style.display = 'block';
		},
		checkInArray(id, old) {
			let match = false;
			for (let i = 0; i < old.length; i++) {
				if (old[i].appointmentId === id) {
					match = true;
					break;
				}
			}
			return match;
		},
		removeNotify(appointment, status) {
			let items = localStorage.getItem("notifyAppointments" + this.plugin);
			let lsitems = {};
			let appointments = [];
			if (items) {
				lsitems = JSON.parse(items);
				appointments = lsitems[status];
				for (let i = 0; i < appointments.length; i++) {
					if (appointment.appointmentId === appointments[i]) {
						appointments.splice(i, 1);
					}
				}
				lsitems[status] = appointments;
				localStorage.setItem('notifyAppointments' + this.plugin, JSON.stringify(lsitems));
				this.getLSitems();
			}
		},
		removeAllNotify(plugin) {
			localStorage.removeItem('notifyAppointments' + plugin);
			this.getLSitems();
		},
		isNotify(appointment) {
			let lsitems = this.lsMap;
			let notify = false;
			let thisApp = appointment.appointmentId;
			if (lsitems) {
				let statusItems = lsitems[appointment.currentStatus];
				notify = statusItems === undefined ? false : statusItems.includes(thisApp);
			}
			return notify;
		}
	}
}
</script>

<style scoped>

</style>